module.exports = __webpack_public_path__ + "static/media/molecular.efa77249.mp4";